import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=3801bd30"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=3801bd30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports